var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isShippableAdress ? _c("shippable-address") : _vm._e(),
      _vm.isBillingAdress ? _c("billing-address") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }